import { createMeasurement, type MeasurementProps } from './createMeasurement';

export type PressureProps = MeasurementProps<'pressure'>;

/** A tyre reading, in kilopascals or pounds per square inch. */
const Pressure = createMeasurement('pressure', 'Pressure');

export default Pressure;
